// export type Nullish<T = undefined> = T | null;

// export type RecruiterDetailsResponse = {
//   login_type: string;
//   brandname: string;
//   user_type: string;
//   is_logged_in: boolean;
//   shared_user: string[];
//   domaintype: string;
//   auth_message: string;
//   is_beta_customer: boolean;
//   companyLogoUrl: string;
//   first_name: string;
//   tracking_id: string;
//   cremail: string;
//   site_context: string;
//   new_search_beta_customer: boolean;
//   "foundit.in": string;
//   subhchannel_id: string;
//   sales_channel: string;
//   last_name: string;
//   recruiter_id: string;
//   is_master_have_child: boolean;
//   ip_address: string;
//   services: string[];
//   is_quick_jp: boolean;
//   salesemail: string;
//   rda_url: string;
//   log_out_url: string;
//   parent_id: string;
//   company_name: string;
//   v4srp_url: string;
//   v4s_url: string;
//   pagetitle: string;
//   session_limit_exceeded: boolean;
//   corp_id: string;
//   channel_id: string;
//   username: string;
// };

export const extractDomain = (baseServer) => {
  let domain = "";
if(typeof window !== 'undefined'){


  const url = window.location.origin;
  if(baseServer){
    domain = baseServer;
  }
  else if (url.includes("localhost") || url.includes("test")) {
    domain = "https://recruiter.foundit.in";
  } else {
    domain = window.location.origin;
  }
}
  return domain;
};

export function extractBaseServer(url) {
  if (url.includes("localhost") || url.includes("test") ) {
    url = "recruiter.foundit.in";
  }

  const parts = url.split('.');
  const domain = parts[parts.length - 2] + '.' + parts[parts.length - 1];

  return domain;
}
export const API_HEADERS = {
  domain: extractDomain(),
};


export const MIDDLEWARE = "/edge/dashboard/middleware";
export const RECRUITER_ACTIONS_MIDDLEWARE = "/edge/dashboard/recruiter-actions-middleware"
const RECRUITER_ACTIONS = '/recruiter-edge-actions/api/v1'

export const ENDPOINTS = {
  getUserData: "/cassowary/session/getuser",
  getHeader: "/recruiter4chat/common/get/header",
  getMasterData: "/edge/recruiter/v4/recruiter-srp/api/v1/master-data",
  getMasterDataRaven: "/edge/recruiter/v4/recruiter-srp/api/v1/ravenMasterData",
  getMasterDataRavenV2: "/edge/recruiter/v4/recruiter-srp/api/v1/masterData-v2",
  fetchManageFolders: "/edge-folder-management/api/v2/folder/personal-folders/",
  getManageFoldersCount: "/edge-folder-management/api/v2/folder/count",
  getProfilesCount: "/edge-folder-management/api/v2/folder/profiles/count/check",
  getCandidatePipelineCount: "/edge-folder-management/api/v2/folder/candidate-pipeline",
  getCampaign: "/outreach-edge-api/api/v1/campaign/overview",
  renameManageFolder: "/edge-folder-management/api/v2/folder/personal",
  getManageFolderRec: "/edge-folder-management/api/v2",
  manageFolderShare: "/edge-folder-management/api/v2/folder/share",
  manageFolderArchive: "/edge-folder-management/api/v2/folder",
  fetchManageFolderCampaigns: "/outreach-edge-api/api/v1/campaign/overview",
  redirectToCampaign: "/outreach-edge-api/api/v1/campaign/initiation",
  redirectToWhatsapp: "/whatsapp-edge-api/api/v1/campaign/initiation",
  getFMHeader: "/edge-folder-management/api/v2/folder/header",
  pauseCampaign: "/outreach-edge-api/api/v1/campaign/pause",
  downloadExcel: "/edge-folder-management/recruiter/v2/downloadExcel",
  fetchMssFolders: "/edge-manage-save-search/api/v2/saved-search",
  getMssFoldersCount: "/edge-manage-save-search/api/v2/saved-search/count",
  mssFolderArchive: "/edge-manage-save-search/api/v2/saved-search",
  renameMssSearch: "/edge-manage-save-search/api/v2/saved-search/rename-search",
  initiateContactability: "/outreach-edge-api/api/v1/contactability/initiate",
  getContactDetails: "/outreach-edge-api/api/v1/contactability/fetch",
  getUserProfiles:"/edge-folder-management/api/v2/folder/filter",
  getCandidatePipeline:"/edge-folder-management/api/v2/folder/candidate-pipeline",
  getSearchInfo:"/edge-manage-save-search/api/v2/saved-search/search/info",
  fetchFolders: `${RECRUITER_ACTIONS}/fetch_folders`,
  saveToFolder: `${RECRUITER_ACTIONS}/saveToFolder`,
  createFolder: `${RECRUITER_ACTIONS}/folder/personal`,
  cloneProfile: `${RECRUITER_ACTIONS}/clone_profile`,
  removeProfile: `${RECRUITER_ACTIONS}/remove_profile`,
  fetchSMSTemplates: `${RECRUITER_ACTIONS}/sms/templates`,
  sendSMS: `${RECRUITER_ACTIONS}/send_sms`,
  restoreProfile: `${RECRUITER_ACTIONS}/restore_profile`,
  moveToState: `${RECRUITER_ACTIONS}/move_to_state`,
  favouriteProfile: `${RECRUITER_ACTIONS}/favourite`,
  getConnections: "/cdp-api-edge/api/v1/connection_insights",
  getSavedData: "/edge-folder-management/edge/card/folders",
  fetchFmProfileContactedDetails: "/outreach-edge-api/api/v1/campaign/get/details-for-profile",
  getLinkedSearch: "/edge-manage-save-search/api/v2/saved-search/linked-search",
  getLinkedSearchUrl: "/edge/recruiter/v4/recruiter-srp/api/v1/getSavedSearch",
  inventory: "/edge-folder-management/api/excel/inventory",
  getFMRecDetails : "/edge-folder-management/api/v2/profile/recruiter",
  getDownloadProfilesPolling :'/edge-folder-management/api/polling/excel',
  healthTracker: "/recruiter-edge-event-tracking/api/v1/tracking/page/load/event",
  checkEmail:"/edge-folder-management/api/excel/mail",
  downloadExcelNew:"/edge-folder-management/recruiter/v3/downloadExcel",
  linkedJob: "/edge-folder-management/api/v2/folder/personal-folders/linked-job",
  getUUIDS:"/edge-folder-management/api/excel/getPuuid",
  getContactableCount:`${RECRUITER_ACTIONS}/validate/sms`,
  getStageTrail: `${RECRUITER_ACTIONS}/seeker/folder/trail`,
  getApplyReplyCount:`/edge-folder-management/api/v2/folder/profile/campaign/count`,
  getAllAssessments: "/edge-folder-management/api/v2/assessment/allAssessments",
  getAssessmentCount: "/edge-folder-management/api/v2/assessment/count",
  requestCredit: "/edge-folder-management/api/v2/assessment/request/credit",
  customRequest: "/edge-folder-management/api/v2/assessment/request/custom",
  initiateAssessment: "/edge-folder-management/api/v2/assessment/initiate/assessment",
  getCandidateDetails:"/edge-folder-management/api/v2/assessment/details/candidates",
  getAssessmentDetails:"/edge-folder-management/api/v2/assessment/details",
  getAssessmentNames:"/edge-folder-management/api/v2/assessment/names",
  getCandidateCount:"/edge-folder-management/api/v2/assessment/details/candidates/count",
  sendAssessment:"/edge-folder-management/api/v2/assessment/send/assessment",
  checkLimit: "/edge-hoatzin/inventory/assessment/check/limit",
  cancelAssessment: "/assessments-integrator/api/v1/cancel/assessment",
  followUp: "/assessments-integrator/api/v1/followup/assessment",
  assessmentRecords: "/edge-folder-management/api/v2/assessment/candidates/count",
  reportSummary: "/edge-folder-management/api/v2/assessment/details/excel",
  allServices: "/hoatzin/inventory/all-services",
};
